// The coach panel's width (--coach-width): the page beside it (Layout.jsx's
// margin) reads it too. The drag handle is ui/PanelResize.
import React from 'react';
import PanelResize, { clampPanelWidth } from '../ui/PanelResize';

export const COACH_WIDTH = { min: 320, standard: 380, max: 760, room: 480 };

export const clampWidth = (px, viewport = 1440) => clampPanelWidth(px, viewport, COACH_WIDTH);

export default function CoachResize() {
  return <PanelResize panelId="coach-panel" cssVar="--coach-width" storageKey="aithlo.coachWidth"
    limits={COACH_WIDTH} label="Resize the coach panel" />;
}
